module.exports = "  <a\n    role=\"button\"\n    [attr.aria-label]=\"displayText\"\n    [class]=\"cssClass\"\n    [class.disabled-command]=\"disabled\"\n    [attr.aria-disabled]=\"disabled\"\n    (click)=\"onClick($event)\"\n    tabindex=\"0\"\n    (keydown)=\"onKeyPress($event)\">\n      <span [load-image]=\"iconUrl\" class=\"icon-small\"></span>\n      {{displayText}}\n  </a>"


//////////////////
// WEBPACK FOOTER
// ./src/app/controls/command-bar/command/command.component.html
// module id = ./src/app/controls/command-bar/command/command.component.html
// module chunks = main